"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const index_1 = require("../index");
const context_1 = require("../../context");
const DocumentContent = () => {
    const { isDesktop } = (0, context_1.useSearchResultContext)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isDesktop ? (0, jsx_runtime_1.jsx)(index_1.FilterGroup, {}) : (0, jsx_runtime_1.jsx)(index_1.MobileFilterButton, {}), (0, jsx_runtime_1.jsx)(index_1.DocumentSearch, {}), !isDesktop && (0, jsx_runtime_1.jsx)(index_1.MobileFilterSideBar, {}), (0, jsx_runtime_1.jsx)(index_1.HitList, {}), (0, jsx_runtime_1.jsx)(index_1.ZeroResult, {})] }));
};
exports.DocumentContent = DocumentContent;
